import React from 'react';
import './Home.scss';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// Common
import btnSocialEmail from '../img/btn-social-email.png';
import btnSocialInstagram from '../img/btn-social-instagram.png';
import btnSocialFacebook from '../img/btn-social-facebook.png';
import btnSocialTwitter from '../img/btn-social-twitter.png';
import comingSoonBorder from '../img/coming-soon-border.png';
import comingSoonLeft from '../img/coming-soon-left.png';
import comingSoonRight from '../img/coming-soon-right.png';
// Mobile
import titleMobile from '../img/title-mobile.png';
import headShop from '../img/head-shop.png';
import headDrawings from '../img/head-drawings.png';
import headProjects from '../img/head-projects.png';
import headSketches from '../img/head-sketches.png';
import headOthers from '../img/head-others.png';
import headWalls from '../img/head-walls.png';
// Desktop
import titleDesktop from '../img/title-desktop.png';
import homeHands from '../img/home-hands.png';
import UserRoleProtected from '../components/UserRoleProtected';
import { Clearance } from '../data/sessionSlice';

type HomeProps = {
  layout: 'heads' | 'hands';
};

class Home extends React.Component<HomeProps> {
  componentDidMount() {
    document.body.classList.add('darker');
  }

  componentWillUnmount() {
    document.body.classList.remove('darker');
  }

  render() {
    // TODO Preload streams.
    switch (this.props.layout) {
      case 'heads':
        return (
          <div className="page heads">
            <Helmet>
              <title>Who Is NemO'S? - Home</title>
              <meta name="theme-color" content="#edd3c1" />
            </Helmet>
            <header>
              <h1>
                <Link to="/">
                  <img className="title-mobile" src={titleMobile} alt="Who is NemO'S?" />
                </Link>
              </h1>
            </header>
            <nav className="links">
              <Link to="/walls" className="head">
                <img src={headWalls} alt="Walls" />
              </Link>
              <Link to="/drawings" className="head">
                <img src={headDrawings} alt="Drawings" />
              </Link>
              <Link to="/sketches" className="head">
                <img src={headSketches} alt="Sketches" />
              </Link>
              <a href="https://nemoshop.bigcartel.com/" target="_blank" className="head">
                <img src={headShop} alt="Shop" />
              </a>
              <UserRoleProtected protectedStyle="unlaunched" clearance={Clearance.InDevelopment}>
                <Link to="/tattoos" className="head">
                  <img src={headOthers} alt="Tattoos" />
                </Link>
              </UserRoleProtected>
              <UserRoleProtected
                protectedStyle="unlaunched"
                clearance={Clearance.InDevelopment}
                fallback={
                  <a href="/" className="head">
                    <img src={headProjects} alt="Projects" />
                    <img src={comingSoonBorder} alt="Coming soon" className="comingSoon projects" />
                  </a>
                }
              >
                <Link to="/projects" className="head">
                  <img src={headProjects} alt="Projects" />
                </Link>
              </UserRoleProtected>
              <UserRoleProtected
                protectedStyle="unlaunched"
                clearance={Clearance.InDevelopment}
                fallback={
                  <a href="/" className="head">
                    <img src={headOthers} alt="Others" />
                    <img src={comingSoonBorder} alt="Coming soon" className="comingSoon others" />
                  </a>
                }
              >
                <Link to="/others" className="head">
                  <img src={headOthers} alt="Others" />
                </Link>
              </UserRoleProtected>
              <UserRoleProtected protectedStyle="unlaunched" clearance={Clearance.InDevelopment}>
                <Link to="/press" className="heads-link">
                  Press
                </Link>
              </UserRoleProtected>
            </nav>
            <nav className="social">
              <a
                href="https://www.instagram.com/whoisnemos/"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialInstagram} alt="Instagram" />
              </a>
              <a
                href="https://twitter.com/whoisnemos"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialTwitter} alt="Twitter" />
              </a>
              <a
                href="https://www.facebook.com/whoisnemos/"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialFacebook} alt="Facebook" />
              </a>
            </nav>
            <nav className="social">
              <a
                href="mailto:info@whoisnemos.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social email"
              >
                <img src={btnSocialEmail} alt="Email" />
              </a>
            </nav>
          </div>
        );
      case 'hands':
        return (
          <div className="page hands">
            <Helmet>
              <title>Who Is NemO'S? - Home</title>
              <meta name="theme-color" content="#edd3c1" />
            </Helmet>
            <header>
              <h1>
                <Link to="/">
                  <img className="title-desktop" src={titleDesktop} alt="Who is NemO'S?" />
                </Link>
              </h1>
            </header>
            <nav className="links">
              <img src={homeHands} alt="Homepage" />
              <Link to="/walls" className="floating left">
                Walls
              </Link>
              <UserRoleProtected
                protectedStyle="unlaunched"
                clearance={Clearance.InDevelopment}
                fallback={
                  <>
                    <a href="/" className="floating disabledLink">
                      Tattoos
                    </a>
                    <img src={comingSoonRight} alt="Coming soon" className="comingSoon" />
                  </>
                }
              >
                <Link to="/tattoos" className="floating right">
                  Tattoos
                </Link>
              </UserRoleProtected>
              <Link to="/drawings" className="floating left">
                Drawings
              </Link>
              <Link to="/sketches" className="floating right">
                Sketches
              </Link>
              <UserRoleProtected
                protectedStyle="unlaunched"
                clearance={Clearance.InDevelopment}
                fallback={<a href="/"> </a>}
              >
                <Link to="/others" className="floating left">
                  Others
                </Link>
              </UserRoleProtected>
              <UserRoleProtected
                protectedStyle="unlaunched"
                clearance={Clearance.InDevelopment}
                fallback={<a href="/"> </a>}
              >
                <Link to="/projects" className="floating right">
                  Projects
                </Link>
              </UserRoleProtected>
              <a href="https://nemoshop.bigcartel.com/" target="_blank" className="floating left">
                Shop
              </a>
              <Link to="/press" className="floating right">
                Press
              </Link>
            </nav>
            <nav className="social">
              <a
                href="https://www.instagram.com/whoisnemos/"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialInstagram} alt="Instagram" />
              </a>
              <a
                href="https://twitter.com/whoisnemos"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialTwitter} alt="Twitter" />
              </a>
              <a
                href="https://www.facebook.com/whoisnemos/"
                target="_blank"
                rel="noopener noreferrer"
                className="social"
              >
                <img src={btnSocialFacebook} alt="Facebook" />
              </a>
              <a
                href="mailto:info@whoisnemos.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social email"
              >
                <img src={btnSocialEmail} alt="Email" />
              </a>
            </nav>
          </div>
        );
      default:
        throw new Error(`Unknown layout: ${this.props.layout}`);
    }
  }
}

export default Home;
